module.exports = __webpack_public_path__ + "img/p2pEmpire.5315ef32.png";